import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const updateRate = (resource, id, lotId, values) => {
  return axios.put(`/api/${resource}/${id}/setup/lots/${lotId}/rates`, values);
};

export const useUpdateRate = (resource, id, lotId) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (values) => updateRate(resource, id, lotId, values),
    onError: (error) => {
      enqueueSnackbar(
        error?.response?.data?.description || error?.message || 'Some error occured',
        {
          variant: 'error',
        }
      );
    },
  });
};
